export const RESTRICTED_SEARCH_MESSAGE =
  "This search term is not allowed. Please search for safe, appropriate content.";

const RESTRICTED_TOKENS = new Set([
  "nude",
  "nudes",
  "naked",
  "porn",
  "porno",
  "pornography",
  "xxx",
  "nsfw",
  "sex",
  "sexual",
  "sexy",
  "erotic",
  "erotica",
  "explicit",
  "topless",
  "strip",
  "stripping",
  "stripper",
  "lingerie",
  "hentai",
  "fetish",
  "escort",
  "prostitute",
  "prostitution",
  "onlyfans",
]);

const RESTRICTED_PHRASES = [
  "call girl",
  "adult video",
  "adult movie",
  "adult content",
];

export const normalizeSearchSafetyText = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const findRestrictedKeyword = (value) => {
  const normalized = normalizeSearchSafetyText(value);
  if (!normalized) return null;

  const tokens = normalized.split(" ").filter(Boolean);
  const blockedToken = tokens.find((token) => RESTRICTED_TOKENS.has(token));
  if (blockedToken) return blockedToken;

  const padded = ` ${normalized} `;
  return (
    RESTRICTED_PHRASES.find((phrase) => padded.includes(` ${phrase} `)) || null
  );
};

export const containsRestrictedKeyword = (value) =>
  Boolean(findRestrictedKeyword(value));

export const isSafeSearchText = (value) => !containsRestrictedKeyword(value);

export const filterSafeSearchValues = (values) =>
  (Array.isArray(values) ? values : []).filter((value) => isSafeSearchText(value));
